import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  hoverEffect?: boolean;
  accent?: boolean;
}
export function Card({
  children,
  className = '',
  hoverEffect = true,
  accent = false
}: CardProps) {
  return <div className={`
        bg-engage-gray1 border border-engage-gray2 rounded-lg p-8
        ${hoverEffect ? 'transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl hover:shadow-engage-yellow/5' : ''}
        ${accent ? 'hover:border-engage-yellow/50' : ''}
        ${className}
      `} data-id="element-78">
      {children}
    </div>;
}